import { render, staticRenderFns } from "./SystemMessageDetail.vue?vue&type=template&id=7195d691&scoped=true"
import script from "./SystemMessageDetail.vue?vue&type=script&lang=js"
export * from "./SystemMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./SystemMessageDetail.vue?vue&type=style&index=0&id=7195d691&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7195d691",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7195d691')) {
      api.createRecord('7195d691', component.options)
    } else {
      api.reload('7195d691', component.options)
    }
    module.hot.accept("./SystemMessageDetail.vue?vue&type=template&id=7195d691&scoped=true", function () {
      api.rerender('7195d691', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/systemmessage/SystemMessageDetail.vue"
export default component.exports